const ecSearchProductCache = new Map();

function ecSearchGetProduct(handle) {
  if (ecSearchProductCache.has(handle)) return Promise.resolve(ecSearchProductCache.get(handle));
  return fetch(`/products/${encodeURIComponent(handle)}.js`)
    .then((response) => {
      if (!response.ok) throw new Error('product-not-found');
      return response.json();
    })
    .then((product) => {
      ecSearchProductCache.set(handle, product);
      return product;
    });
}

function ecSearchFindVariant(product, color, size, colorOptionIndex, sizeOptionIndex) {
  return product.variants.find((variant) => {
    const variantColorOption = colorOptionIndex ? variant[`option${colorOptionIndex}`] : null;
    const variantSizeOption = sizeOptionIndex ? variant[`option${sizeOptionIndex}`] : null;
    if (colorOptionIndex && sizeOptionIndex) {
      return variantColorOption === color && variantSizeOption === size;
    }
    if (colorOptionIndex && !sizeOptionIndex) return variantColorOption === color;
    if (!colorOptionIndex && sizeOptionIndex) return variantSizeOption === size;
    return false;
  });
}

function ecSearchRefreshSizes(row, product, color, colorOptionIndex, sizeOptionIndex) {
  const sizeNodes = row.querySelectorAll('[data-ec-search-size]');
  if (!sizeNodes.length) return;
  sizeNodes.forEach((sizeElement) => {
    const size = sizeElement.dataset.ecSearchSize;
    const variant = ecSearchFindVariant(product, color, size, colorOptionIndex, sizeOptionIndex);
    const isVariantAvailable = variant && variant.available;
    sizeElement.disabled = !isVariantAvailable;
    sizeElement.classList.toggle('ec-search-modal__variant-size-btn--sold-out', !isVariantAvailable);
  });
}

function ecSearchVariantImageUrl(variant) {
  const featuredImage = variant?.featured_image;
  if (!featuredImage) return '';
  const imageSrc = typeof featuredImage === 'string' ? featuredImage : featuredImage.src;
  if (!imageSrc) return '';
  return imageSrc.startsWith('//') ? `https:${imageSrc}` : imageSrc;
}

function ecSearchUpdatePrice(row, variant) {
  const wrap = row.querySelector('[data-ec-search-price-wrap]');
  if (!wrap || !variant) return;

  const formatMoney = (cents) => {
    if (window.Shopify?.formatMoney) {
      return window.Shopify.formatMoney(cents, window.Shopify.moneyFormat || '{{amount}}');
    }
    return 'R$\u00a0' + (cents / 100).toFixed(2).replace('.', ',');
  };

  if (variant.compare_at_price && variant.compare_at_price > variant.price) {
    wrap.innerHTML =
      `<span class="ec-search-modal__price-compare">${formatMoney(variant.compare_at_price)}</span>` +
      `<span class="ec-search-modal__price">${formatMoney(variant.price)}</span>`;
  } else {
    wrap.innerHTML = `<span class="ec-search-modal__price">${formatMoney(variant.price)}</span>`;
  }
}

function ecSearchApplyVariant(row, variant, fallbackImageUrl = '') {
  const link = row.querySelector('.ec-search-modal__product-main-link');
  if (!link || !variant) return;

  row.dataset.ecVariantId = String(variant.id);

  try {
    const productLinkUrl = new URL(link.getAttribute('href'), window.location.origin);
    productLinkUrl.searchParams.set('variant', String(variant.id));
    link.setAttribute('href', productLinkUrl.pathname + productLinkUrl.search + productLinkUrl.hash);
  } catch {
    const rawHref = link.getAttribute('href') || '';
    const path = rawHref.split('?')[0];
    link.setAttribute('href', `${path}?variant=${variant.id}`);
  }

  ecSearchUpdatePrice(row, variant);

  const imgEl = row.querySelector('[data-ec-search-product-img]');
  const src = ecSearchVariantImageUrl(variant) || fallbackImageUrl;
  if (imgEl && src) imgEl.src = src;
}

document.addEventListener('click', (event) => {
  const btn = event.target.closest('[data-ec-search-color], [data-ec-search-size]');
  if (!btn || !btn.closest('.ec-search-modal')) return;

  const row = btn.closest('[data-ec-search-row]');
  if (!row) return;

  event.preventDefault();
  event.stopPropagation();

  const handle = row.dataset.ecProductHandle;
  const colorOptionIndex = parseInt(row.dataset.ecColorOption || '0', 10);
  const sizeOptionIndex = parseInt(row.dataset.ecSizeOption || '0', 10);

  ecSearchGetProduct(handle)
    .then((product) => {
      if (btn.hasAttribute('data-ec-search-color')) {
        row.querySelectorAll('[data-ec-search-color]').forEach((colorButton) => {
          colorButton.classList.toggle('ec-search-modal__variant-color-btn--active', colorButton === btn);
        });

        const imgEl = row.querySelector('[data-ec-search-product-img]');
        const thumbUrl = btn.dataset.ecImg;
        if (imgEl && thumbUrl) imgEl.src = thumbUrl;

        const color = btn.dataset.ecSearchColor;
        ecSearchRefreshSizes(row, product, color, colorOptionIndex, sizeOptionIndex);

        let sizeBtn = row.querySelector('[data-ec-search-size].ec-search-modal__variant-size-btn--active');
        if (!sizeBtn || sizeBtn.disabled) {
          sizeBtn = row.querySelector('[data-ec-search-size]:not(:disabled)');
        }
        if (sizeBtn) {
          sizeBtn.classList.add('ec-search-modal__variant-size-btn--active');
        }

        const size = sizeBtn ? sizeBtn.dataset.ecSearchSize : null;
        const variant = ecSearchFindVariant(product, color, size, colorOptionIndex, sizeOptionIndex);
        if (variant) ecSearchApplyVariant(row, variant, thumbUrl);
      } else {
        row.querySelectorAll('[data-ec-search-size]').forEach((sizeButton) => {
          sizeButton.classList.toggle('ec-search-modal__variant-size-btn--active', sizeButton === btn);
        });

        const colorBtn = row.querySelector('[data-ec-search-color].ec-search-modal__variant-color-btn--active');
        const color = colorBtn ? colorBtn.dataset.ecSearchColor : null;
        const thumbUrl = colorBtn ? colorBtn.dataset.ecImg : '';
        const size = btn.dataset.ecSearchSize;
        const variant = ecSearchFindVariant(product, color, size, colorOptionIndex, sizeOptionIndex);
        if (variant) ecSearchApplyVariant(row, variant, thumbUrl);
      }
    })
    .catch(() => {});
});

function ecSearchActiveInHostSection(host, active, selector) {
  return Boolean(active && host.contains(active) && active.closest(selector));
}

class EcSearchModal extends HTMLElement {
  connectedCallback() {
    this.detailsRoot = this.closest('details');
    this.modalRoot = this.closest('.ec-search-modal');
    this.input = this.querySelector('.ec-search-modal__input');
    this.predictive = this.querySelector('predictive-search');
    this.idleEl = this.querySelector('[data-ec-search-idle]');
    this.selectedEl = this.querySelector('[data-ec-search-selected]');
    this.focusCollectionEl = this.querySelector('[data-ec-search-focus-collection]');

    this.detailsModal = this.closest('details-modal');
    const textTrigger = this.detailsModal?.querySelector('.ec-search-modal__text-trigger');
    const closeBtn = this.querySelector('.ec-search-modal__close-button');

    textTrigger?.addEventListener('click', (event) => {
      event.preventDefault();
      const summary = this.detailsRoot?.querySelector('summary');
      if (summary && !this.detailsRoot.hasAttribute('open')) {
        summary.click();
      }
    });

    closeBtn?.addEventListener('click', () => {
      if (this.detailsModal?.close) {
        this.detailsModal.close();
      } else {
        this.detailsRoot?.removeAttribute('open');
      }
    });

    this.addEventListener('focusin', () => this.syncState());
    this.addEventListener('focusout', () => setTimeout(() => this.syncState(), 180));
    this.input?.addEventListener('input', () => this.syncState());

    if (this.predictive) {
      const predictiveObserver = new MutationObserver(() => this.syncState());
      predictiveObserver.observe(this.predictive, {
        attributes: true,
        attributeFilter: ['open', 'loading', 'results'],
      });
    }

    this.detailsRoot?.addEventListener('toggle', () => {
      if (!this.detailsRoot.hasAttribute('open')) {
        this.panel?.classList.remove('ec-search-modal__panel--visible');
        this.overlay?.classList.remove('ec-search-modal__overlay--visible');
        return;
      }
      this.modalRoot = this.closest('.ec-search-modal') || this.modalRoot;
      this.panel = this.modalRoot?.querySelector('.ec-search-modal__panel');
      this.overlay = this.modalRoot?.querySelector('.modal-overlay');
      requestAnimationFrame(() => {
        this.panel?.classList.add('ec-search-modal__panel--visible');
        this.overlay?.classList.add('ec-search-modal__overlay--visible');
        if (this.focusCollectionEl && this.focusCollectionEl.dataset.empty !== 'true') {
          this.input?.focus({ preventScroll: true });
        }
        this.syncState();
      });
    });

    this.syncState();
  }

  syncState() {
    const searchQuery = this.input?.value.trim() ?? '';
    const active = document.activeElement;
    const inputEl = this.input;
    const onInput = Boolean(inputEl && active === inputEl);
    const inFocusCollectionArea = ecSearchActiveInHostSection(
      this,
      active,
      '[data-ec-search-focus-collection]'
    );
    const inSelectedArea = ecSearchActiveInHostSection(this, active, '[data-ec-search-selected]');

    const focusForFocusCollection = onInput || inFocusCollectionArea;
    const focusForSelected = onInput || inSelectedArea;
    const loading = this.predictive?.hasAttribute('loading');
    const predictiveOpen = this.predictive?.hasAttribute('open');
    const predictiveEnabled = Boolean(this.predictive);

    const showPredictive = Boolean(
      predictiveEnabled && (predictiveOpen || loading) && searchQuery.length > 0
    );

    const hasFocusCollection = Boolean(
      this.focusCollectionEl && this.focusCollectionEl.dataset.empty !== 'true'
    );

    const showFocusCollection = Boolean(
      !showPredictive && searchQuery.length === 0 && focusForFocusCollection && hasFocusCollection
    );

    const hasSelected = Boolean(
      this.selectedEl && this.selectedEl.dataset.empty !== 'true'
    );

    const showSelected = Boolean(
      !showPredictive &&
        !showFocusCollection &&
        searchQuery.length === 0 &&
        focusForSelected &&
        hasSelected
    );

    const showIdle = Boolean(
      !showPredictive && !showFocusCollection && !showSelected && searchQuery.length === 0
    );

    this.classList.toggle('ec-search-modal--predictive-visible', showPredictive);
    this.classList.toggle('ec-search-modal--focus-collection-visible', showFocusCollection);
    this.classList.toggle('ec-search-modal--selected-visible', showSelected);
    this.classList.toggle('ec-search-modal--idle-visible', showIdle);
  }
}

customElements.define('ec-search-modal', EcSearchModal);
